import adminApiClient from './apiClient.js';

export const cacheArtistasApi = {
  listDiarios: async () => {
    const { data } = await adminApiClient.get('/cache-artistas/diarios');
    return data;
  },
  criarExecucao: async (payload) => {
    const { data } = await adminApiClient.post('/cache-artistas/execucoes', payload);
    return data;
  },
  listExecucoes: async (limit = 20) => {
    const { data } = await adminApiClient.get('/cache-artistas/execucoes', { params: { limit } });
    return data;
  },
  getExecucao: async (id) => {
    const { data } = await adminApiClient.get(`/cache-artistas/execucoes/${id}`);
    return data;
  },
  getInsights: async () => {
    const { data } = await adminApiClient.get('/cache-artistas/insights');
    return data;
  },
  listAgendamentos: async () => {
    const { data } = await adminApiClient.get('/cache-artistas/agendamentos');
    return data;
  },
  criarAgendamento: async (payload) => {
    const { data } = await adminApiClient.post('/cache-artistas/agendamentos', payload);
    return data;
  },
  atualizarAgendamento: async (id, payload) => {
    const { data } = await adminApiClient.patch(`/cache-artistas/agendamentos/${id}`, payload);
    return data;
  },
  removerAgendamento: async (id) => {
    await adminApiClient.delete(`/cache-artistas/agendamentos/${id}`);
  },
};

export default cacheArtistasApi;
